import { render, staticRenderFns } from "./AllSms.vue?vue&type=template&id=6ed05a84"
import script from "./AllSms.vue?vue&type=script&lang=js"
export * from "./AllSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports